// 在元素接近 viewport（預設往外 200px 預載）時觸發一次 onVisible 後即斷開觀察。
// IntersectionObserver 屬 widget baseline（docs/browser-baseline.md ✅），可直接用、免 polyfill。
export function observeNearViewport(
  el: Element,
  onVisible: () => void,
  rootMargin = '200px',
): () => void {
  const io = new IntersectionObserver((entries) => {
    if (entries.some(e => e.isIntersecting)) {
      io.disconnect()
      onVisible()
    }
  }, { rootMargin })
  io.observe(el)
  return () => io.disconnect()
}
